import {Routes} from '@angular/router';

// Components
import {NotFound404PageCmp} from '../pages/not-found-404-page.cmp';
import {CatalogPageCmp} from '../../catalog/pages/catalog.cmp';
import {SummaryPageCmp} from '../../catalog/pages/summary.cmp';

export const ROUTES: Routes = [
    {
        path: '',
        redirectTo: '/catalog',
        pathMatch: 'full'
    },
    {
        path: 'catalog',
        component: CatalogPageCmp
    },
    {
        path: 'catalog/:topCategory',
        component: CatalogPageCmp
    },
    {
        path: 'summary',
        component: SummaryPageCmp
    },
    {
        path: '**',
        component: NotFound404PageCmp
    }
];


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/shared/routes/app-routes.ts